<template>
    <div id="app">

        <Login v-if="user.id == null"></Login>
        <Main v-else></Main>
    </div>
</template>

<style>
    #app {
        height: 100%;
    }

</style>

<script>
    import {mapState, mapMutations} from "vuex";
    import Main from './views/Main';
    import Login from './views/Login';

    export default {
        data() {
            return {
                tokenTimer: null, //自动token续期的定时器
            }

        },
        components: {
            Main,
            Login
        },
        computed: {
            ...mapState({
                user: state => state.user,
                storageHandlers: state => state.storageHandlers,
            })
        },
        watch: {
            user: function (newUser, oldUser) {
                if (newUser.id != oldUser.id) {
                    if (this.tokenTimer) {
                        window.clearInterval(this.tokenTimer);
                        this.tokenTimer = null;
                        console.debug("关闭定时器");
                    }
                    //每两分钟检测一下是否需要更新token
                    if (newUser.id) {
                        console.debug("每两分钟检测一下token是否需要更新");
                        this.tokenTimer = window.setInterval(()=> {
                            this.refreshToken()
                        }, 120000);
                        console.debug("开启定时器");
                    }

                } else if (newUser.id && this.tokenTimer == null) { //刷新页面进来，userId不变，这时候也要开启定时器
                    this.tokenTimer = window.setInterval(()=> {
                        this.refreshToken()
                    }, 120000);
                    console.debug("开启定时器");
                }
            }
        },
        methods: {
            ...mapMutations([
                "setUser",
                "reLogin",
                "addStorageHandler",
                "openTab"
            ]),
            loadUserInfo() {
                return this.$ajaxGet("/user/getSelfInfo", data => {
                    this.setUser(data.result);
                    document.getElementById("titleName").innerHTML = data.result.institutionName;
                }, () => {
                    this.ssoLogin();
                })
            },
            /**
             * 监听Localstorage，如果其他页面退出了，即时更新用户状态
             */
            listenLocalStorage() {
                let _this =this;
                //跨页面localstorage改变
                window.addEventListener("storage", (e) => {
                    this.storageHandlers.forEach(item => {
                        item.handler(e);
                    })
                });
            },
            refreshToken() {
                if (window.checkTokenNeedRefresh()) {
                    this.$ajaxGet("/login/refreshToken", data => {
                        window.updateLocalToken(data.result);
                    })
                }
            },
            loadTab(){
                let type = window.getUrlParam("type");
                let id = window.getUrlParam("id");
                if(type == 'codeBase'){
                    setTimeout(() => {//加个延迟加载 要不在首页前面加载
                        this.openTab({
                            funcKey: "school_page_code_base_sharing_manage",
                            title: "代码库共享",
                            allowDuplicate: true,
                            attr: {
                                id:id
                            }
                        });
                    }, 500);
                }
                if(type == 'platformCodeBase'){
                    setTimeout(() => {//加个延迟加载 要不在首页前面加载
                        this.openTab({
                            funcKey: "school_page_platform_code_base_sharing_manage",
                            title: "平台代码库",
                            allowDuplicate: true,
                            attr: {
                                id:id
                            }
                        });
                    }, 500);
                }
                if(type == 'prepareLesson'){
                    setTimeout(() => {//加个延迟加载 要不在首页前面加载
                        this.openTab({
                            funcKey: "school_page_prepare_lessons_sharing_manage",
                            title: "备课共享",
                            allowDuplicate: true,
                            attr: {
                                id:id
                            }
                        });
                    }, 500);
                }
                if(type == 'lessonSeries'){
                     setTimeout(() => {//加个延迟加载 要不在首页前面加载
                         this.openTab({
                             funcKey: "school_page_lesson_series",
                             title: "课程包",
                             allowDuplicate: true
                         });
                     }, 600);
                }
                if(type == 'systemUpgrade'){
                     setTimeout(() => {//加个延迟加载 要不在首页前面加载
                         this.openTab({
                             funcKey: "school_menu_agent_info",
                             title: "系统升级",
                             allowDuplicate: true
                         });
                     }, 600);
                }
                if (type == 'teaching') {
                    setTimeout(() => {//加个延迟加载 要不在首页前面加载
                        this.openTab({
                            funcKey: "school_menu_doteach_manage",
                            title: "上课管理",
                            allowDuplicate: false
                        });
                    }, 600);
                }
            },
            ssoLogin() {

            }
        },
        created() {
            let token = window.getLocalToken();
            if (token) {
                this.loadUserInfo().then(()=> {
                    this.loadTab();
                    this.refreshToken();
                })
            } else {
                this.reLogin();
                this.ssoLogin();
            }

            this.addStorageHandler({
                key: "refreshToken",
                handler: (e) => {
                    if (e.key == "token") {
                        console.debug("其他页面刷新了token:", new Date(), e);//token清空了，就是有个页面退出了
                        if (e.newValue) {
                            this.loadUserInfo();
                        } else {
                            this.reLogin();
                        }
                    }
                }
            })

            this.listenLocalStorage();
        },

        beforeDestroy() {
            if (this.tokenTimer) {
                window.clearInterval(this.tokenTimer);
            }
        }

    }
</script>
